import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { DatasourceTableJobStore } from '@y42/datasource';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'integration-table-job', idKey: 'request_id' })
export class IntegrationTableJobStore extends DatasourceTableJobStore {
  constructor() {
    super();
  }
}
